
// angular
// .module('HeroPRO')
const HPLogging = {
    LogLevel: {
        Trace: 1000,
        Debug: 2000,
        Info: 3000,
        Warn: 4000,
        Error: 5000,
        Fatal: 6000,
    },
};

export default HPLogging;



// WEBPACK FOOTER //
// ./src/app/config/constants/logLevels.constant.js